<app-page-title title="Relatório"></app-page-title>
<section>
  <form [formGroup]="form" class="form">
    <mat-form-field class="field" appearance="outline">
      <mat-label>Data inicial</mat-label>
      <input type="email" matInput formControlName="startDate" type="date" />
    </mat-form-field>
    <br />
    <mat-form-field class="field" appearance="outline">
      <mat-label>Data final</mat-label>
      <input type="email" matInput formControlName="endDate" type="date" />
    </mat-form-field>
    <button class="btn-primary" (click)="submit()" [disabled]="!form.valid">gerar</button>
  </form>
</section>
